import { navItems } from "../interfaces";
import { myitem } from "../types/myitem";
import { config } from "./config";

const navElements: Array<navItems> = [
  {
    path: `${config.BASE_URL}/`,
    text: "Home",
    icon: "home",
  },
];

const imprintNav: Array<navItems> = [
  {
    path: `${config.BASE_URL}/imprint`,
    text: "imprint",
    icon: ""
  },
];

const fetchNavElements = async (): Promise<Array<navItems>> => {
  try {
    const response = await fetch(
      process.env.PUBLIC_URL + "/generatedNavElements.json"
    );
    const generatedNavElements = await response.json();

    if (generatedNavElements) {
      const mappedNavElements = generatedNavElements.map(
        (element: navItems) => {
          const BASE_URL = config.BASE_URL;
          if (element.expandableMenuItems) {
            return {
              ...element,
              path: element.path.replace("{config.BASE_URL}", `${BASE_URL}`),
              expandableMenuItems:
                element.expandableMenuItems?.map((item: myitem) => {
                  return {
                    ...item,
                    to: item.to.replace("{config.BASE_URL}", `${BASE_URL}`),
                  };
                }) || null,
            };
          }
          return {
            ...element,
            path: element.path.replace("{config.BASE_URL}", `${BASE_URL}`),
          };
        }
      );

      // Update navElements with the mapped elements
      return [...navElements, ...mappedNavElements, ...imprintNav];
    }
    return navElements;
  } catch (error) {
    return navElements;
  }
};

export default fetchNavElements;
